{
    "Accessibility menu": "Μενού Προσβασιμότητας",
    "Close": "Κλείσιμο",
    "Text and Reading": "Κείμενο και ανάγνωση",
    "Navigation and Interaction": "Πλοήγηση και αλληλεπίδραση",
    "Text Align": "Στοίχιση κειμένου",
    "Align Left": "Στοίχιση Αριστερά",
    "Align Center": "Στοίχιση στο κέντρο",
    "Align Right": "Στοίχιση δεξιά",
    "Adjust Font Size": "Προσαρμογή Μεγέθους Γραμματοσειράς",
    "Highlight Title": "Επισήμανση Τίτλου",
    "Highlight Links": "Επισήμανση Συνδέσμων",
    "Readable Font": "Αναγνώσιμη Γραμματοσειρά",
    "Color and Contrast": "Χρώμα και αντίθεση",
    "Dark Contrast": "Σκούρη Αντίθεση",
    "Light Contrast": "Ανοιχτή Αντίθεση",
    "High Contrast": "Υψηλή Αντίθεση",
    "High Saturation": "Υψηλός Κορεσμός",
    "Low Saturation": "Χαμηλός Κορεσμός",
    "Monochrome": "Μονόχρωμο",
    "Tools": "Εργαλεία",
    "Reading Guide": "Οδηγός Ανάγνωσης",
    "Big Cursor": "Μεγάλος Δρομέας",
    "Increase Font Size": "Αύξηση Μεγέθους Γραμματοσειράς",
    "Decrease Font Size": "Μείωση Μεγέθους Γραμματοσειράς",
    "Letter Spacing": "Διάστημα Γραμμάτων",
    "Line Height": "Ύψος Γραμμής",
    "Font Weight": "Πάχος Γραμματοσειράς",
    "Dyslexia Font": "Γραμματοσειρά για Δυσλεξία",
    "Language": "Γλώσσα",
    "Accessibility widget": "Άνοιγμα Μενού Προσβασιμότητας",
    "Accessibility Profiles": "Προφίλ Προσβασιμότητας",
    "Cognitive Disability": "Γνωστική Αναπηρία",
    "Seizure Safe": "Ασφαλές για Επιληψία",
    "Accessibility statement": "Δήλωση Προσβασιμότητας",
    "ADHD": "ΔΕΠΥ",
    "Low Vision": "Χαμηλή όραση",
    "Pause Animations": "Διακοπή Κινούμενων Εικόνων",
    "Animation paused": "Κινούμενη εικόνα σε παύση",
    "Reset all settings": "Επαναφορά ρυθμίσεων",
    "Shortcut:": "Συντόμευση:",
    "Epilepsy Safe Mode": "Λειτουργία ασφαλής για επιληψία",
    "Mute sounds": "Σίγαση ήχων",
    "Page read": "Ανάγνωση σελίδας",
    "Page read controls": "Στοιχεία ελέγχου ανάγνωσης σελίδας",
    "Pause": "Παύση",
    "Resume": "Συνέχεια",
    "Stop": "Διακοπή",
    "Settings": "Ρυθμίσεις",
    "Speed": "Ταχύτητα",
    "Voice": "Φωνή",
    "Close accessibility menu": "Κλείσιμο μενού προσβασιμότητας",
    "Back to accessibility menu": "Επιστροφή στο μενού προσβασιμότητας",
    "Search languages": "Αναζήτηση γλωσσών",
    "Selected language": "Επιλεγμένη γλώσσα",
    "View accessibility statement (opens in new window)": "Προβολή δήλωσης προσβασιμότητας (ανοίγει σε νέο παράθυρο)",
    "Visit CookieYes website (opens in new window)": "Επίσκεψη στον ιστότοπο CookieYes (ανοίγει σε νέο παράθυρο)",
    "Reset all accessibility settings to default": "Επαναφορά όλων των ρυθμίσεων προσβασιμότητας στις προεπιλογές"
}
